import React from 'react'
import Nav from '../../common/Nav';
import '../Home/home.css';
const Destination = () => {
  return (
    <div className="container-fluid overflow-auto body ">
    <div className=' container-fluid  '>
      <Nav />
     
      <div className='rawTxt'>
        <p> Destination Coming Soon</p>
      </div>
      </div>
      </div>
  )
}

export default Destination